import { paths } from '../constants';

export const getIntlPath = (path: keyof typeof paths) => {
    const language = location.pathname.substring(1, 3);

    return `/${language}/${paths[path]}`;
};
